<template>
    <el-dialog
        :append-to-body="true"
        title="选择需要添加的商品"
        :visible.sync="centerDialogVisible"
        width="60%"
    >
        <el-row>
            <div style="margin-bottom: 10px">
                <el-cascader
                    clearable
                    v-model="pageData.data.categoryIdList"
                    :options="categoryData"
                    :props="{ expandTrigger: 'hover' }"
                    class="row-item"
                    @change="handleChange">
                </el-cascader>
                <el-input v-model="pageData.data.suggest" class="row-item" placeholder="请输入商品编码/名称"></el-input>
                <el-button v-on:click="search" type="primary">搜索</el-button>
            </div>
            <el-table
                ref="multipleTable"
                v-loading="loading"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="300"
                @selection-change="handleSelectionChange">
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    prop="goodsCategoryName"
                    label="分类名称"
                    width="200">
                </el-table-column>
                <el-table-column
                    prop="skuName"
                    label="商品名称"
                    width="200">
                    <template slot-scope="scope">{{filterStr(scope.row.skuName)}}</template>
                </el-table-column>
                <el-table-column
                    prop="barCode"
                    label="69码"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="availableAmount"
                    label="可用库存"
                    width="70">
                </el-table-column>
                <el-table-column
                    prop="hunitPrice"
                    label="原价"
                    width="70">
                </el-table-column>
                <el-table-column
                    prop="hitemPrice"
                    label="成交价"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-input type="text" v-model="scope.row.hitemPrice" @keyup.native="upNumber($event)" placeholder="请输入成交价"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="practicalGoods"
                    label="数量"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-input type="text" v-model="scope.row.practicalGoods" @keyup.native="upNumber($event)" placeholder="请输入数量"></el-input>
                    </template>
                </el-table-column>
            </el-table>
            <div style="text-align: right;margin-top: 10px">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageData.pageNo"
                    :page-sizes="[5, 10, 20, 100]"
                    :page-size="pageData.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pageData.totalCount">
                </el-pagination>
            </div>
        </el-row>

        <div slot="footer">
            <el-button type="primary" v-on:click="add">确认</el-button>
            <el-button @click="centerDialogVisible = false">取消</el-button>
        </div>
    </el-dialog>
</template>
<script>
import {getPrepareDetailSelect} from "@/modules/server-api/prepare/prepareDetailSelect";
import {OrderGoodsApi} from "@/modules/server-api/commodity-sys/order-goods";

export default {
    name: "dialogGoodsList",
    props: {
        client: {
            type: Object
        },
        goodsList: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data() {
        return {
            centerDialogVisible: false,
            formData: {
                goodsList: [],
                category: null
            },
            selectList: [],
            tableData: [],
            categoryData: [],
            loading: true,
            pageData: {
                data: {
                    buyer: null,
                    buyerType: 0,
                    categoryIdList: [],
                    goodsType: "NORMAL",
                    suggest: "",
                    boxUnit: "盒"

                },
                pageNo: 1,
                pageSize: 20,
                totalCount: 0,
                totalPageCount: 0,

            },
        }
    },
    mounted() {
        this.getCategory();
    },
    methods: {
        getCategory() {
            console.log('getCategory');
            getPrepareDetailSelect.getDetailSelectList({}).then(resp => {
                if (resp) {
                    let result = resp.result;
                    let categoryOpts = [];
                    this.getCategoryLoop(result, categoryOpts);
                    console.log(categoryOpts)
                    this.categoryData = categoryOpts;
                    console.log(this.categoryData)
                    // this.$forceUpdate();
                }
            });
        },
        getCategoryLoop(result, categoryOpts) {
            for (let i in result) {
                let data = result[i];
                let children = [];
                if (data.children && data.children.length > 0) {
                    this.getCategoryLoop(data.children, children);
                }

                if (children.length === 0) {
                    categoryOpts.push({
                        value: data.id,
                        label: data.categoryName
                    });
                } else {
                    categoryOpts.push({
                        value: data.id,
                        label: data.categoryName,
                        children: children
                    });
                }
            }
            // console.log('getCategoryLoop', categoryOpts)
        },
        getGoodsTableData() {
            //根据入库单获取商品
            OrderGoodsApi.getAllGoodsList(this.pageData).then(resp => {
                // console.log('getGoodsTableData', resp)
                if (resp && resp.succ === 1) {
                    let result = resp.result;
                    this.tableData = result.list.filter(item => {
                        let goodsList = this.goodsList;
                        let isBreak = false;
                        for (let n in goodsList) {
                            let goods = goodsList[n];
                            if (goods.skuCode === item.skuCode) {
                                isBreak = true;
                                break;
                            }
                        }
                        return isBreak ? null : item;
                    });
                    this.pageData.totalCount = result.totalCount;
                    this.loading = false;
                }else{
                    this.$notifyError(resp.error);
                    this.loading = false;
                }
            })
        },
        handleSelectionChange(val) {
            console.log('handleSelectionChange', val);
            this.formData.selectList = val;
        },
        handleChange(val) {
            console.log('handleChange', val, this.formData.category);
        },
        handleSizeChange(val) {
            console.log('handleSizeChange', val);
            this.loading = true;
            this.pageData.pageSize = val;
            this.getGoodsTableData();
        },
        handleCurrentChange(val) {
            console.log('handleCurrentChange', val);
            this.loading = true;
            this.pageData.pageNo = val;
            this.getGoodsTableData();
        },
        open() {
            this.centerDialogVisible = true;
            console.log('open ', this.categoryData);
            // this.categoryData = this.categoryData.map(item => {
            //     return item;
            // });
            this.pageData.data.buyer = this.client.id;
            this.getGoodsTableData();
        },
        search() {
            this.loading = true;
            this.getGoodsTableData();
        },
        add() {
            console.log('get goodsList', this.goodsList)
            let goods = this.formData.selectList.map(item =>{
                return item;
            });
            this.$parent.$parent.addGoods(this.goodsList.concat(goods));
            this.formData.category = ''
            this.centerDialogVisible = false;
        },
        upNumber(e){
            // console.log('231',e.target.value);
            e.target.value = e.target.value.replace(/[^\d]/g,'')
            console.log('231',e.target.value);

        }
    }
}
</script>
<style>
.el-input {
    width: auto;
}

.row-item {
    margin-right: 10px;
}

.el-dialog__body{
    padding-top: 10px;
    padding-bottom: 10px;
}
</style>
